/* LauVéA – cartes produit (v2) : un clic sur une pastille affiche la photo de cette couleur ; toutes les photos de la fiche défilent au glissé du doigt (téléphone) ; 2e photo au survol (ordinateur) */
(function () {
  if (window.__lvCartes) return;
  window.__lvCartes = true;

  var WRAP = '[class*="ai-product-grid__image-wrapper-"]';
  var CARD = '[class*="ai-product-grid__card-"], .card-wrapper';

  var css = [
    WRAP + ' .lv-img2{opacity:0;transition:opacity .3s ease;pointer-events:none}',
    '@media (hover:hover){' + WRAP + ':hover .lv-img2{opacity:1}}',
    WRAP + ' .lv-img2.is-on{opacity:1}',
    '.lv-dots{display:none;position:absolute;left:0;right:0;bottom:8px;z-index:3;justify-content:center;gap:5px;pointer-events:none}',
    '@media (hover:none){.lv-dots{display:flex}}',
    '.lv-dots i{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.8);box-shadow:0 0 0 1px rgba(0,0,0,.15)}',
    '.lv-dots i.on{background:#77494c}',
    '.lauvea-swatch.is-active{border-color:#77494c;box-shadow:inset 0 0 0 2px #fff,0 0 0 1px #77494c}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function mediaOf(card) { return card.querySelector(WRAP + ', .card__media'); }
  function mainOf(card) {
    var m = mediaOf(card);
    return m ? m.querySelector('img:not(.lv-img2)') : null;
  }
  function setDots(card) {
    var dots = card.querySelectorAll('.lv-dots i');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === (card._lvIdx || 0));
  }
  /* Affiche la photo n° idx : la 1re est la photo principale, les autres passent par la couche du dessus */
  function render(card) {
    var s2 = card.querySelector('img.lv-img2');
    var list = card._lvList || [];
    if (!s2 || list.length < 2) return;
    var idx = card._lvIdx || 0;
    var url = idx === 0 ? list[1] : list[idx];
    if (s2.getAttribute('data-cur') !== url) {
      s2.removeAttribute('srcset');
      s2.src = url;
      s2.setAttribute('data-cur', url);
    }
    s2.classList.toggle('is-on', idx > 0);
    setDots(card);
  }
  function preloadAll(list) {
    for (var i = 0; i < list.length; i++) { var im = new Image(); im.src = list[i]; }
  }

  /* Photos supplémentaires : uniquement sur la grille des collections */
  function setupCard(card) {
    if (card._lvDone) return;
    var wrap = card.querySelector(WRAP);
    if (!wrap) return;
    card._lvDone = true;
    var d = card.querySelector('.lv-data');
    var main = mainOf(card);
    if (!d || !main) return;
    var all = (d.getAttribute('data-all') || '').split('|').filter(Boolean);
    if (all.length < 2) return;
    card._lvList = all;
    card._lvIdx = 0;
    var img = document.createElement('img');
    img.className = main.className + ' lv-img2';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.src = all[1];
    img.setAttribute('data-cur', all[1]);
    main.parentNode.appendChild(img);
    var dots = document.createElement('span');
    dots.className = 'lv-dots';
    var h = '';
    for (var i = 0; i < all.length; i++) h += '<i' + (i === 0 ? ' class="on"' : '') + '></i>';
    dots.innerHTML = h;
    wrap.appendChild(dots);
  }
  function scan() {
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) setupCard(cards[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(scan, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Clic sur une pastille : la photo de la carte change */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a.lauvea-swatch') : null;
    if (!a || !a.getAttribute('data-lv-img')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    var card = a.closest(CARD);
    var main = card ? mainOf(card) : null;
    if (!main) return;
    e.preventDefault();
    var url = a.getAttribute('data-lv-img');
    main.src = url;
    if (a.getAttribute('data-lv-srcset')) main.srcset = a.getAttribute('data-lv-srcset');
    else main.removeAttribute('srcset');
    if (a.getAttribute('data-lv-alt')) main.alt = a.getAttribute('data-lv-alt');
    if (card._lvList) {
      var rest = [];
      for (var k = 0; k < card._lvList.length; k++) if (card._lvList[k] !== url) rest.push(card._lvList[k]);
      card._lvList = [url].concat(rest);
      card._lvIdx = 0;
      render(card);
    }
    var prev = card.querySelectorAll('a.lauvea-swatch.is-active');
    for (var i = 0; i < prev.length; i++) prev[i].classList.remove('is-active');
    a.classList.add('is-active');
    var link = main.closest('a');
    if (link) link.href = a.href;
    var title = card.querySelector('h3 a');
    if (title) title.href = a.href;
  });

  /* Pré-charge la photo dès qu'on approche la pastille, et toutes les photos de la carte au premier contact */
  var cache = {};
  function preload(e) {
    var a = e.target.closest ? e.target.closest('a.lauvea-swatch') : null;
    var u = a && a.getAttribute('data-lv-img');
    if (u && !cache[u]) { cache[u] = true; new Image().src = u; }
    var c = e.target.closest ? e.target.closest(CARD) : null;
    if (c && c._lvList && !c._lvPre) { c._lvPre = true; preloadAll(c._lvList); }
  }
  document.addEventListener('mouseover', preload);
  document.addEventListener('touchstart', preload, { passive: true });

  /* Téléphone : glisser le doigt sur la photo pour faire défiler toutes les photos */
  var sx = 0, sy = 0, sc = null;
  document.addEventListener('touchstart', function (e) {
    var w = e.target.closest ? e.target.closest(WRAP) : null;
    if (!w || e.touches.length !== 1) { sc = null; return; }
    sc = w.closest(CARD);
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!sc) return;
    var tc = e.changedTouches[0];
    var dx = tc.clientX - sx, dy = tc.clientY - sy;
    var card = sc;
    sc = null;
    if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var list = card._lvList;
    if (!list || list.length < 2) return;
    var idx = card._lvIdx || 0;
    if (dx < 0) idx = Math.min(idx + 1, list.length - 1);
    else idx = Math.max(idx - 1, 0);
    card._lvIdx = idx;
    render(card);
  }, { passive: true });
})();
